var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadarChartImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 421,
    height: 304,
    viewBox: "0 0 421 304",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211.004 145.465V24.1816",
    stroke: "#D1B3F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M211.004 145.465L271.646 40.4307",
    stroke: "#D1B3F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M211.004 145.465L316.038 84.8232",
    stroke: "#D1B3F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M211.004 145.465H332.287",
    stroke: "#D1B3F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M211.004 145.465L316.038 206.106",
    stroke: "#D1B3F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M211.004 145.465L271.646 250.499",
    stroke: "#D1B3F4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M211.004 145.465V266.748",
    stroke: "#D1B3F4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M211.005 145.465L150.363 250.499",
    stroke: "#D1B3F4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M211.007 145.465L105.973 206.106",
    stroke: "#D1B3F4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M211.006 145.465H89.7227",
    stroke: "#D1B3F4"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M211.007 145.465L105.973 84.8232",
    stroke: "#D1B3F4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M211.005 145.465L150.363 40.4307",
    stroke: "#D1B3F4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M211.004 110.812L228.33 115.455L241.014 128.139L245.656 145.465L241.014 162.791L228.33 175.475L211.004 180.117L193.678 175.475L180.994 162.791L176.352 145.465L180.994 128.139L193.678 115.455L211.004 110.812Z",
    stroke: "#D1B3F4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M211.004 76.1611L245.656 85.4462L271.024 110.813L280.309 145.466L271.024 180.118L245.656 205.485L211.004 214.771L176.352 205.485L150.984 180.118L141.699 145.466L150.984 110.813L176.352 85.4462L211.004 76.1611Z",
    stroke: "#D1B3F4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M211.006 24.1816L271.647 40.4305L316.04 84.8232L332.289 145.465L316.04 206.106L271.647 250.499L211.006 266.748L150.364 250.499L105.972 206.106L89.7227 145.465L105.972 84.8232L150.364 40.4305L211.006 24.1816Z",
    stroke: "#D1B3F4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M211.004 41.5098L262.982 55.4374L301.033 93.4883L280.309 145.467L301.033 197.445L262.982 235.496L211.004 249.424L159.025 235.496L120.974 197.445L107.047 145.467L120.974 93.4883L159.025 55.4374L211.004 41.5098Z",
    fill: "#6A09DD",
    fillOpacity: 0.1,
    stroke: "#6A09DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadarChartImage);
export default __webpack_public_path__ + "static/media/RadarChartImage.4dcb03ca66b3bc582a6cb7aa51ddd1da.svg";
export { ForwardRef as ReactComponent };